<script setup>
// Paketin fiziksel yolculuğu: 📦 Çıkış → 🚛 Transfer → 🏢 Varış şubesi → 🚚 Dağıtımda.
// Kart ve detayda AYNI bileşen kullanılır (çift çubuk olmasın). Renk nötr mavi —
// yolda olmak kötü haber değil; kırmızı sadece kapanış akıbetinde kullanılır.
// Renkler doğrudan hex (özel Tailwind paleti standart tonları üretmiyor).
import { computed } from 'vue';

const props = defineProps({
  item: { type: Object, required: true },
});

const STEPS = ['📦 Çıkış', '🚛 Transfer', '🏢 Varış şubesi', '🚚 Dağıtımda'];

const current = computed(() => {
  const s = String(props.item.cargo_status || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
  if (props.item.on_vehicle_today) return 3;
  if (s.includes('alici subede') || s.includes('kargo subede')) return 2;
  if (s.includes('gonnderici') || s.includes('gonderici')) return 0;
  return 1; // Yolda / Aktarma / Dönüş Yolunda
});
const pct = computed(() => (current.value / (STEPS.length - 1)) * 100);

const fmtWhen = t => {
  if (!t) return '';
  const d = new Date(t);
  return `${d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
};
</script>

<template>
  <div>
    <div class="flex justify-between mb-1">
      <div
        v-for="(st, ix) in STEPS"
        :key="ix"
        class="flex-1 flex flex-col items-center"
      >
        <span
          class="w-3 h-3 rounded-full inline-block"
          :class="ix === current ? 'animate-pulse' : ''"
          :style="
            ix <= current
              ? `background:#2563eb;box-shadow:0 0 0 3px ${ix === current ? '#bfdbfe' : 'transparent'}`
              : 'background:#e5e7eb'
          "
        />
        <span
          class="text-[10px] leading-tight text-center mt-1"
          :class="
            ix === current ? 'font-bold text-n-slate-12' : 'text-n-slate-10'
          "
          >{{ st }}</span
        >
      </div>
    </div>
    <div class="h-1.5 rounded-full overflow-hidden" style="background: #e5e7eb">
      <div
        class="h-full rounded-full"
        :style="`width:${pct}%;background:linear-gradient(90deg,#2563eb,#60a5fa)`"
      />
    </div>
    <div class="text-xs text-n-slate-11 mt-1.5">
      📍 Son nokta:
      <span class="font-semibold text-n-slate-12">{{
        item.last_location || item.branch || '—'
      }}</span>
      <template v-if="item.last_movement">
        · {{ item.last_movement }}
        <span v-if="item.last_movement_at" class="text-n-slate-10"
          >({{ fmtWhen(item.last_movement_at) }})</span
        >
      </template>
    </div>
  </div>
</template>
